import React from 'react';
import { RadioInput, RadioInputGroup } from '@instructure/ui-radio-input';
import t from 'format-message';
import { ScoreDisplayFormat } from "../../../../util/gradebook/constants.js";
export var ScoreDisplayFormatSelector = function ScoreDisplayFormatSelector(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? ScoreDisplayFormat.ICON_ONLY : _ref$value,
    onChange = _ref.onChange;
  var inputs = [{
    value: ScoreDisplayFormat.ICON_ONLY,
    label: t('Icons Only')
  }, {
    value: ScoreDisplayFormat.ICON_AND_POINTS,
    label: t('Icons + Points')
  }, {
    value: ScoreDisplayFormat.ICON_AND_LABEL,
    label: t('Icons + Descriptor')
  }];
  var handleChange = function handleChange(event) {
    onChange(event.target.value);
  };
  return /*#__PURE__*/React.createElement(RadioInputGroup, {
    onChange: handleChange,
    name: "score-display-format",
    value: value.toString(),
    description: t('Scoring')
  }, inputs.map(function (input) {
    return /*#__PURE__*/React.createElement(RadioInput, {
      key: input.value,
      value: input.value.toString(),
      label: input.label
    });
  }));
};